import { render, staticRenderFns } from "./remove-prod.vue?vue&type=template&id=b5b54006&scoped=true"
import script from "./remove-prod.vue?vue&type=script&lang=js"
export * from "./remove-prod.vue?vue&type=script&lang=js"
import style0 from "./remove-prod.vue?vue&type=style&index=0&id=b5b54006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b54006",
  null
  
)

export default component.exports